<template>
  <!-- begin sidebar nav -->
  <ul class="nav" v-if="menus">
    <li class="text-left">
      <a :href="'/dashboard/highlights'" class="navbar-brand" style="justify-content: flex-start; margin-right: 0">
        <template v-if="!this.pageOptions.pageSidebarMinified">
          <img class="w-auto h-100" src="@/assets/img/Logo/AHM Logo.png" />
        </template>
        <template v-else>
          <img style="width: 32px; height: 32px" class="w-auto" src="@/assets/img/Logo/ahm-logo-square.png" />
        </template>
        <!-- <span>Genuine Parts</span> -->
      </a>
    </li>
    <li>
      <template v-if="!this.pageOptions.pageSidebarMinified">
        <div class="switcher-apps">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_10198_13764)">
              <path
                d="M18 4.5H12.6667C11.564 4.5 10.6667 5.39733 10.6667 6.5V20.5H20V6.5C20 5.39733 19.1027 4.5 18 4.5ZM18.6667 19.1667H12V6.5C12 6.13267 12.2993 5.83333 12.6667 5.83333H18C18.3673 5.83333 18.6667 6.13267 18.6667 6.5V19.1667ZM7.33333 6.5H8.66667V18.5H7.33333V6.5ZM4 8.5H5.33333V16.5H4V8.5Z"
                fill="#383838" />
            </g>
            <defs>
              <clipPath id="clip0_10198_13764">
                <rect width="16" height="16" fill="white" transform="translate(4 4.5)" />
              </clipPath>
            </defs>
          </svg>

          <div class="application-list">
            <span class="app-list-label">AHM Product</span>

            <select v-model="currentApp" @change="handleAppSwitch">
              <option v-if="currentAppName" :value="currentApp" disabled>
                {{ currentAppName === 'Brake Pad / Brake Shoe' ? 'Brake Shoe / Pad' : currentAppName }}
              </option>
              <option v-for="app in switchApps" :key="app.id" :value="app.id">
                {{ getAppDisplayName(app.name) }}
              </option>
            </select>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="switcher-apps">
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_10198_13764)">
              <path
                d="M18 4.5H12.6667C11.564 4.5 10.6667 5.39733 10.6667 6.5V20.5H20V6.5C20 5.39733 19.1027 4.5 18 4.5ZM18.6667 19.1667H12V6.5C12 6.13267 12.2993 5.83333 12.6667 5.83333H18C18.3673 5.83333 18.6667 6.13267 18.6667 6.5V19.1667ZM7.33333 6.5H8.66667V18.5H7.33333V6.5ZM4 8.5H5.33333V16.5H4V8.5Z"
                fill="#383838" />
            </g>
            <defs>
              <clipPath id="clip0_10198_13764">
                <rect width="16" height="16" fill="white" transform="translate(4 4.5)" />
              </clipPath>
            </defs>
          </svg>

          <div class="application-list">
            <select v-model="currentApp" @change="handleAppSwitch">
              <!-- <option v-if="currentAppName" :value="currentApp" disabled hidden class="option-hidden">
                {{ currentAppName }}
              </option> -->
              <option v-for="app in switchApps" :key="app.id" :value="app.id">
                {{ getAppDisplayName(app.name) }}
              </option>
            </select>
          </div>
        </div>
      </template>
    </li>
    <li class="profile">
      <div class="profile-pic" @click="editProfile">
        <img src="@/assets/img/user/user-default.jpg" />
      </div>

      <div class="username" v-if="!this.pageOptions.pageSidebarMinified">
        <h4>{{ user ? user.username : "-" }}</h4>
        <p class="m-0 user-type">
          {{ user ? formatUserType(user.type) : "-" }}
        </p>
      </div>
    </li>
    <!-- <li class="nav-header">Navigation</li> -->
    <sidebar-nav-list v-for="menu in menus" v-bind:key="menu.path" ref="sidebarNavList" v-bind:menu="menu" v-bind:scrollTop="scrollTop" v-bind:status="menu.status"
      v-on:collapse-other="handleCollapseOther(menu)" v-on:showFloatSubmenu="handleShowFloatSubmenu"
      v-on:hideFloatSubmenu="handleHideFloatSubmenu"></sidebar-nav-list>
  </ul>
  <!-- end sidebar nav -->
</template>

<script>
import SidebarMenu from "./SidebarMenu.vue";
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "@/Options/PageOptions.js";

export default {
  name: "SidebarNav",
  props: ["scrollTop"],
  components: {
    SidebarNavList,
  },
  data() {
    return {
      menus: SidebarMenu,
      pageOptions: PageOptions,
      modules: [],
      user: this.$store.getters.currentUser,
      productCategories: this.$store.getters.getProductCategory,
      categoryIdMap: [],
      /* categoryIdMap: {
        oil: 1,
        "pad;shoe": 2,
        vanbelt: 3,
      }, */
    };
  },
  created() {
    // this.getModules();
    console.log("created");
    this.getAllApps();
  },
  mounted() {
    // this.getModules();
    //this.getAllApps();
  },
  computed: {
    // filteredMenu() {
    //   const isSuperAdmin = this.user.super_admin;
    //   const sidebarMenu = this.menus;

    //   if (isSuperAdmin === 0) {
    //     // console.log("Hello I'm admin", isSuperAdmin);
    //     const filtered = sidebarMenu.filter((menu) => menu.title !== "User Management");
    //     // console.log("sidebar remove user management", sidebarMenu);

    //     return filtered;
    //   }

    //   // console.log("Hello I'm super admin", isSuperAdmin);
    //   return sidebarMenu;
    // },
    switchApps() {
      return this.productCategories;
    },
    currentAppName() {
      if (!this.productCategories || this.productCategories.length === 0) {
        return "Loading...";
      }

      const selectedCategory = this.user.product_category;
      let selectedAppId = this.categoryIdMap[selectedCategory];

      let check = this.productCategories.find(
        (detail) => detail.product_category_code == selectedCategory
      );
      if (check) {
        selectedAppId = check.id;
      }

      if (selectedAppId) {
        const selectedApp = this.productCategories.find((app) => app.id === selectedAppId);
        return selectedApp ? this.getAppDisplayName(selectedApp.name) : "";
      } else {
        return "No App Selected";
      }
    },
  },
  methods: {
    getAppDisplayName(name) {
      return name === 'Brake Pad / Brake Shoe' ? 'Brake Shoe / Pad' : name;
    },
    handleShowFloatSubmenu: function (menu, offset) {
      this.$emit("showFloatSubmenu", menu, offset);
    },
    handleHideFloatSubmenu: function () {
      this.$emit("hideFloatSubmenu");
    },
    handleCollapseOther: function (menu) {
      for (var i = 0; i < this.menus.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu);
      }
    },
    getModules() {
      let modules = JSON.parse(JSON.stringify(this.$store.state.modules));
      let userAccess = this.$store.getters.currentUser;

      if (userAccess.role.length == 0 || userAccess.role[0].id == 1) {
        //Excluding Admins
      } else if (userAccess.role[0].id == 2) {
        //Excluding User Color
        modules = [
          {
            code: null,
            icon: "fas fa-clipboard",
            path: "/work-order-listing",
            title: "List Work Order",
          },
        ];
      } else if (userAccess.role.length > 0) {
        let i = 0;
        while (modules[i]) {
          if (!modules[i].children) {
            if (userAccess.permissions.indexOf(modules[i].code) == -1) modules.splice(i, 1);
            else i++;
          } else {
            let j = 0;
            while (modules[i].children[j]) {
              if (userAccess.permissions.indexOf(modules[i].children[j].code) == -1)
                modules[i].children.splice(j, 1);
              else j++;
            }
            if (modules[i].children.length == 0) modules.splice(i, 1);
            else i++;
          }
        }
      }

      this.menus = modules;
    },

    editProfile() {
      this.$router.push({ path: "/edit-profile" });
    },

    async getAllApps() {
      try {
        // console.log(`masuk bos ${this.user.token}`);
        const token = this.user.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        let resp = await this.$httpSSO.get("/api/admin/feeds/product-category", { headers });

        //console.log(JSON.stringify(resp.data.data));
        this.categoryIdMap = resp.data.data;

        // Save to Vuex global state
        this.$store.dispatch("setProductCategory", resp.data.data);

        // Update local productCategories from global state
        this.productCategories = resp.data.data;

        this.initializeCurrentApp();
      } catch (err) {
        console.error("Error fetching data:", err);
        // console.error("Error response status:", err.response.status);
        // console.error("Error response data:", err.response.data);
      }
    },

    handleAppSwitch() {
      if (this.currentApp) {
        const selectedApp = this.switchApps.find((app) => app.id === this.currentApp);
        const token = this.user.token;
        const isRemember = localStorage.getItem("isRemember");
        const redirectUrl = `${selectedApp.url}/cross-client?product_category_id=${this.currentApp}&token=${token}&isRemember=${isRemember}`;

        // let redirectUrl;
        // if (this.currentApp === 2) {
        //   redirectUrl = `http://localhost:8082/cross-client?product_category_id=${this.currentApp}&token=${token}`;
        // } else {
        //   redirectUrl = `http://localhost:8081/cross-client?product_category_id=${this.currentApp}&token=${token}`;
        // }
        window.location.href = redirectUrl;
        // console.log(this.currentApp);
      } else {
        // console.log("No app selected.");
      }
    },
    formatUserType(type) {
      if (!type) return "-";
      return type.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    },
  },
};
</script>

<style scoped>
.username {
  font-size: 15px;
  display: inline-block;
  width: 100%;
  white-space: normal;
  overflow: visible !important;
}

.page-sidebar-minified .profile-pic {
  width: 32px;
  height: 32px;
}

.page-sidebar-minified .switcher-apps {
  background-color: transparent;
  margin: 0;
}

.page-sidebar-minified .switcher-apps>*:first-child {
  padding-left: 0;
  flex-basis: 100%;
}

.page-sidebar-minified .switcher-apps>*:last-child {
  padding-right: 0;
  flex-basis: 100%;
}

.page-sidebar-minified .switcher-apps .application-list {
  position: absolute;
  top: 0;
  right: 4px;
}

.page-sidebar-minified .switcher-apps .application-list select {
  padding: 8px;
}

.switcher-apps {
  background-color: #f2f2f2;
  border-radius: 4px;
  padding: 4px 0;
  margin: 0 20px;
  display: flex;
  align-items: center;
}

.switcher-apps>*:first-child {
  padding-left: 2px;
  flex-basis: 48px;
}

.switcher-apps>*:last-child {
  padding-right: 8px;
  flex-basis: 70%;
}

.switcher-apps span,
.switcher-apps select,
.switcher-apps option {
  color: #383838;
}

.switcher-apps select,
.switcher-apps option {
  width: 100%;
}

.switcher-apps span {
  font-weight: 400;
  padding-left: 4px;
}

.app-list-label {
  font-size: 10px;
}

.user-type {
  font-size: 10px;
  color: #bebebe;
}

.switcher-apps select {
  font-weight: 700;
  padding: 4px 0;
  border: 0;
  /* appearance: none; */
  background: none;
}

.application-list {
  display: flex;
  flex-direction: column;
}

.profile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  overflow: visible !important;
}

.page-sidebar-minified .profile {
  padding: 10px;
}

.profile-pic {
  width: 48px;
  height: 48px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.profile-pic img {
  width: 100%;
}

.profile-pic+* {
  text-align: center;
}

.profile h4 {
  margin: 0;
}
</style>
